<m-option-item :icon-name="iconName"
               :disabled="disabled"
               @click="onClick">
    {{ label }}
</m-option-item>
